import { AcceptanceDocumentsKeyType } from '../../keys';

const acceptanceDocumentsKeys: AcceptanceDocumentsKeyType = {
  accepting: 'Accepting...',
  actionRequired: 'Action required',
  confirmConsent: 'I confirm that I have read and agree to the',
  dearUser: 'Dear User,',
  notReadyToAccept: 'Not ready to accept?',
  restrictedAccessNotice:
    'Access to your account is restricted until you accept the updated documents.',
  termsUpdateDescription:
    'Following the update of the legal entity operating the Archivizer platform, the documents governing your use of the platform have been updated. To continue using your account, please review and accept the updated documents.',
  updatedDocuments: 'updated documents',
  updatedTerms: 'Updated Terms'
};

export default acceptanceDocumentsKeys;
